export const ACTIONS = {
  INSURANCE: 'INSURNACE',
  INSURANCE_DETAILS_START: 'INSURANCE_DETAILS_START',
  INSURANCE_DETAILS_SUCCESS: 'INSURANCE_DETAILS_SUCCESS',
  INSURANCE_DETAILS_FAILURE: 'INSURANCE_DETAILS_FAILURE',
};
